import { ComponentType } from "./component-type";

export enum DemoView { 
    Button,
    StepOne,
    ConsumerPortal = ComponentType.CONSUMER_PORTAL,
    ConsumerAdmin = ComponentType.ADMIN,
    QuickLink = ComponentType.QUICK_LINK
}